var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28582615,0.223868073 L35.2230926,18.8263965 C36.0773996,19.3755939 36.0773996,20.6244061 35.2230926,21.1736035 L6.28582615,39.7761319 C5.35731122,40.3730344 4.13617714,39.7063548 4.13617714,38.6025284 L4.13617714,1.39747156 C4.13617714,0.293645248 5.35731122,-0.373034386 6.28582615,0.223868073 Z M6.9265564,3.95299228 L6.9265564,36.0470077 L31.8885684,20 L6.9265564,3.95299228 Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.cb8f2b41615d747ed94d863c6f7aad88.svg";
export { ForwardRef as ReactComponent };